export default "__VITE_ASSET__kWPV7vG1__"